import type { JSX } from "react";

import { PAGE_META } from "./content.js";
import { LegalPage } from "./LegalPage.js";
import { TERMS_OF_USE } from "./legal-content.js";

/** `/terms` — the Terms of Use for the portal (2026-09-14). */
export function TermsPage(): JSX.Element {
  return <LegalPage content={TERMS_OF_USE} meta={PAGE_META.terms} />;
}
